module.exports = __webpack_public_path__ + "static/media/img-04.80635df0.jpg";